import React from 'react';
import { PiggyBankIcon, CalendarCheckIcon, UnlockIcon, RepeatIcon, ZapIcon, MessageCircleIcon, TagIcon, ShieldCheckIcon } from 'lucide-react';
import type { BenefitIcon } from '../../data/membership';
const icons: Record<BenefitIcon, React.ComponentType<{
  className?: string;
}>> = {
  piggy: PiggyBankIcon,
  calendar: CalendarCheckIcon,
  unlock: UnlockIcon,
  repeat: RepeatIcon,
  zap: ZapIcon,
  message: MessageCircleIcon,
  tag: TagIcon,
  shield: ShieldCheckIcon
};
interface MembershipBenefitsProps {
  title: string;
  benefits: {
    icon: BenefitIcon;
    text: string;
  }[];
}
export function MembershipBenefits({
  title,
  benefits
}: MembershipBenefitsProps) {
  return <div className="mt-20" data-id="element-268" data-mp="19gi51gir16tj">
      <h3 className="font-display text-2xl font-bold text-navy" data-id="element-269" data-mp="19fqdqhw6pv92">{title}</h3>
      <ul className="mt-6 grid gap-x-8 gap-y-5 border-t border-navy/10 pt-6 sm:grid-cols-2 lg:grid-cols-4" data-id="element-270" data-mp="3771emr4y2xmo">
        {benefits.map(benefit => {
        const Icon = icons[benefit.icon];
        return <li key={benefit.text} className="flex items-start gap-3 text-sm font-medium text-navy" data-id="element-271" data-mp="9uyak2s42af1">
              <Icon className="mt-0.5 h-5 w-5 shrink-0 text-brand-blue" aria-hidden="true" data-id="element-272" data-mp="52yc6erovpkk" />
              {benefit.text}
            </li>;
      })}
      </ul>
    </div>;
}